import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValgFilterDialogComponent } from "@valg-shared/components/table/table/valg-filter-dialog/valg-filter-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ValgInputModule } from '@valg-shared/components/input/input.module';

@NgModule({
  declarations: [ ValgFilterDialogComponent ],
  exports: [ ValgFilterDialogComponent ],
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule,
    ValgInputModule,
    FormsModule
  ]
})
export class ValgFilterDialogModule { }
